import LocalStorage from './_localStorage'

export default new LocalStorage('_sbdat')
